import React from 'react';
import { ADALONG_COLORS } from '@src/styles';
import { style } from 'typestyle';

interface Props {
  childrenRender: (color: string) => JSX.Element;
  width?: number;
  height?: number;
}

export interface InheritProps {
  selected?: boolean;
  onClick: (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => any;
  width?: number;
  height?: number;
}

export function IconRender({ onClick, selected, childrenRender, width, height }: Props & InheritProps) {
  const strokeColor = selected ? ADALONG_COLORS.FLASH_BLUE : ADALONG_COLORS.DARKER_GRAY;
  const strokeWidth = selected ? 2 : 1;
  
  return (
    <svg className={svgClass(width, height)} viewBox='0 0 80 80' onClick={onClick}>
      <g stroke='none' strokeWidth={strokeWidth} fill='none' fillRule='evenodd'>
        {childrenRender(strokeColor)}
      </g>
    </svg>
  );
}

const svgClass = (width?: number, height?: number) => style({
  cursor: 'pointer',
  width: width ? width : 30,
  height: height ? height : (width ? width : 30),
});
